import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS,ADMIN_USER_ROLE } from '../const.config';
import {
  checkAdminUserRole,
} from '../../utils/local-cache.util';

const getAdminRole = checkAdminUserRole();
// Channels module configurations
export const LISTING_COLUMNS = [
  {
    id: 'code',
    label: 'Code',
    width: '20%',
    align: 'left',
    dataKey: 'code',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'title',
    label: 'Title',
    width: '25%',
    align: 'left',
    dataKey: 'title',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    width: '20%',
    align: 'center',
    dataKey: 'status',
    sortable: true,
    type: CELL_DATA_TYPES.SWITCH,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    width: '20%',
    align: 'center',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'modifiedAt',
    label: 'Modified Date',
    width: '20%',
    align: 'center',
    dataKey: 'modifiedAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.CONFIG.value,
    label: ACTIONS.CONFIG.label,
  },
  {
    action: ACTIONS.EDIT.value,
    label: ACTIONS.EDIT.label,
    conditional: () => getAdminRole === ADMIN_USER_ROLE.ADMIN,
  },
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
  {
    action: ACTIONS.SEQUENCE.value,
    label: ACTIONS.SEQUENCE.label,
    conditional: (val) => Number(val.categoriesCount) > 1,
  },
  {
    action: ACTIONS.DELETE.value,
    label: ACTIONS.DELETE.label,
    conditional: () => getAdminRole === ADMIN_USER_ROLE.ADMIN,
  }
];

export const VIEW_CHANNELS_COLUMNS = [
  {
    id: 'name',
    label: 'Title',
    dataKey: 'title',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'description',
    label: 'Description',
    dataKey: 'description',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    dataKey: 'status',
    type: CELL_DATA_TYPES.STATUS,
  },
  {
    id: 'code',
    label: 'Code',
    dataKey: 'code',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    dataKey: 'createdAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'modifiedAt',
    label: 'Modified Date',
    dataKey: 'modifiedAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];